import { render, staticRenderFns } from "./form-organizations-users-add.vue?vue&type=template&id=054372e0&lang=pug"
import script from "./form-organizations-users-add.vue?vue&type=script&lang=js"
export * from "./form-organizations-users-add.vue?vue&type=script&lang=js"
import style0 from "./form-organizations-users-add.vue?vue&type=style&index=0&id=054372e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports